import { useEffect, useState } from 'react';
import { useGetUserById } from 'domains/admin/hooks/useGetUserById';

const AdminInfo = ({ adminId }) => {
  const [adminName, setAdminName] = useState(null);
  const { getUserById, loading, error } = useGetUserById();

  useEffect(() => {
    const fetchAdminName = async () => {
      const admin = await getUserById(adminId);
      if (admin) {
        setAdminName(admin.displayName);
      }
    };

    if (adminId) {
      fetchAdminName();
    }
  }, [adminId, getUserById]);

  if (loading) return <>Loading...</>;
  if (error) return <>Error</>;

  return <>{adminName}</>;
};

export default AdminInfo;
